import { observer } from 'mobx-react-lite'
import { PrimaryControls } from '@/features/jobs/list/components/JobManagement/JobsViewerHeader/PrimaryControls'
import { FilterControlsContainer } from '@/components/FilterControls/FilterControlsContainer'
import { JobsViewerHeader } from '@/features/jobs/list/components/JobManagement/JobsViewerHeader'
import { useToggle } from '@/hooks/state-hooks'
import { type JobManagementViewModel } from '@/features/jobs/list/JobManagementViewModel'
import { TableControlsContainer } from '@/features/jobs/list/components/JobManagement/JobsViewerHeader/TableControls/TableControlsContainer'

export interface JobsViewerHeaderContainerProps {
  vm: JobManagementViewModel
}

export const JobsViewerHeaderContainer = observer(
  function JobsViewerHeaderContainer({ vm }: JobsViewerHeaderContainerProps) {
    const hasFilters = vm.searcher.filters.appliedFilterCount > 0
    const showingFilterControls = useToggle(hasFilters)

    return (
      <JobsViewerHeader>
        <PrimaryControls
          renderMenu={(button) => (
            <TableControlsContainer vm={vm} button={button} />
          )}
          onChange={vm.searcher.searchText.change}
          onShowFilterControls={showingFilterControls.toggle}
          filterCount={vm.searcher.filters.appliedFilterCount}
          value={vm.searcher.searchText.value}
        />
        <FilterControlsContainer
          active={showingFilterControls.isEnabled}
          vm={vm.searcher.filters}
          editorTestId="job"
          testId="job-filter"
        />
      </JobsViewerHeader>
    )
  },
)
